import React from "react";
import PropTypes from "prop-types";
import { HotjarMasked } from "@a0/support-center-components";
import { StyledReactSelect } from "./StyledReactSelect";

/**
 * A drop-in replacement for the ./SelectInput.js component, except that
 * is drawn using react-select instead of a standard <select> HTML tag.
 */
export const ReactSelectInput = (props) => {
  const { name, label, onChange, defaultOption, disabled, value, error, hotjarMasked, options } =
    props;

  // props.value is a single value (as in a <select> element), not the actual object
  // from the array of options used by react-select
  // so we look up the initially selected object by matching the value
  const selectedOption =
    options.find((option) => option.value === value)
    // if the current option is not found, react-select wants "null"
    || null;

  function handleChange(item) {
    const event = {
      target: {
        name,
        value: item && item.value
      }
    };
    onChange(event);
  }

  function getOptionLabel(option) {
    return option.text;
  }

  const selectComponent = (
    <StyledReactSelect
      name={name}
      value={selectedOption}
      options={options}
      onChange={handleChange}
      isDisabled={disabled}
      placeholder={defaultOption}
      getOptionLabel={getOptionLabel}
    />
  );

  return (
    <div className="form-group">
      {label && (
        <label className="control-label" htmlFor={name}>
          {label}
        </label>
      )}
      <div className="field">
        {/* Note, value is set here rather than on the option - docs: https://facebook.github.io/react/docs/forms.html */}
        {hotjarMasked && <HotjarMasked>{selectComponent}</HotjarMasked>}
        {!hotjarMasked && selectComponent}
        {error && <div className="alert alert-danger">{error}</div>}
      </div>
    </div>
  );
};

ReactSelectInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  defaultOption: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.object),
  disabled: PropTypes.bool,
  hotjarMasked: PropTypes.bool
};
